import {i18n} from 'src/i18n';
import AbsenceService from 'src/modules/absence/absenceService';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

import moment from 'moment-timezone';
import absenceListActions from '../list/absenceListActions';

const prefix = 'ABSENCE_FORM';

const absenceFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  //SET_RECORD: `${prefix}_SET_RECORD`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: absenceFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AbsenceService.find(id);
      }

      dispatch({
        type: absenceFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: absenceFormActions.INIT_ERROR,
      });

      getHistory().push('/ausencia');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: absenceFormActions.CREATE_STARTED,
      });

      await AbsenceService.create(values);

      dispatch({
        type: absenceFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.absence.create.success'));

      //getHistory().push('/ausencia');
      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerAbsenceListPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: 'AbsenceListPage',
        }),
      );
      return true;
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: absenceFormActions.CREATE_ERROR,
      });
      return false;
    }
  },

  doUpdate:
    (id, values, edited: any = null) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: absenceFormActions.UPDATE_STARTED,
        });

        await AbsenceService.update(id, values);

        if (edited) edited(id, values);

        dispatch({
          type: absenceFormActions.UPDATE_SUCCESS,
        });
        dispatch({
          type: absenceListActions.PATCH_RECORD,
          payload: {id, values},
        });

        if (!values.silent) {
          Message.success(i18n('entities.absence.update.success'));
        }

        // getHistory().goBack();

        if (!values.updating) {
          dispatch(
            layoutActions.doVisibleDrawer({
              drawerId: 'DrawerAbsenceFormPage',
              drawerVisible: false,
              drawerChanged: moment().unix(),
              drawerUpdateComponent: 'AbsenceListPage',
            }),
          );
        }
        return true;
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: absenceFormActions.UPDATE_ERROR,
        });
        return false;
      }
    },
  setRecord: (values) => async (dispatch) => {
    try {
      dispatch({
        type: absenceFormActions.INIT_SUCCESS,
        payload: values,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: absenceFormActions.INIT_ERROR,
      });
    }
  },
};

export default absenceFormActions;
